(function () {
    'use strict';

    angular
        .module('app')
        .controller('DashboardHomeCtrl', DashboardHomeCtrl);

    DashboardHomeCtrl.$inject = [
        'DialogService',
        'DashboardSettingsService',
        'NavigationAidService'];

    function DashboardHomeCtrl(
        DialogService,
        DashboardSettingsService,
        NavigationAidService) {

        /* jshint validthis:true */
        var vm = this;
        vm.entityTemplates = [];
        vm.dashboardSettings = [];
        vm.loadDashboardSettings = loadDashboardSettings;
        vm.setupPanelLayoutSizes = setupPanelLayoutSizes;

        activate();

        function activate() {
            NavigationAidService.setTitle('Dashboard');
            setupPanelLayoutSizes();
            loadDashboardSettings();
        }

        function loadDashboardSettings() {
            DashboardSettingsService.query({
                filterByAcl: true
            })
                .then(getDashboardSettingsOk, getDashboardSettingsError);

            function getDashboardSettingsOk(data) {
                // Prepare the configuration for dashboard panels of entity type
                _.forEach(data.DashboardSettings, function (dashboardSetting) {
                    if (dashboardSetting.Type === 'Entities') {
                        dashboardSetting.Configuration.EntityTemplateId = dashboardSetting.EntityTemplateId;
                    }
                });

                vm.dashboardSettings = data;
            }

            function getDashboardSettingsError(response) {
                DialogService.error('Error fetching Dashboard Panels', response);
            }
        }

        function setupPanelLayoutSizes() {
            vm.panelLayoutSizes = [];

            vm.panelLayoutSizes.Half = {
                        Flex: 50,
                        Flexsm: 100,
                        Flexxs: 100
            };

            vm.panelLayoutSizes.Full = {
                        Flex: 100,
                        Flexsm: 100,
                        Flexxs: 100
            };
        }
    }
})();
